<mat-label class="subHeading">Net Premium<span *ngIf="isRequired" class="star">*</span></mat-label>

<div formGroupName="net_premium" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
